import apiFetch from "@/lib/fetch";

export async function loadedTrainers({
  districtId,
  occupationId,
  page,
}: {
  districtId?: number;
  occupationId?: number;
  page: number;
}) {
  let route = `trainer?index=${page}`;

  if (districtId) {
    route += `&districtId=${String(districtId)}`;
  }
  if (occupationId) {
    route += `&occupationId=${occupationId}`;
  }

  return await apiFetch({
    route,
  });
}

export async function fetchTrainerVenues({
  districtId,
  occupationId,
  page,
}: {
  districtId?: number;
  occupationId?: number;
  page: number;
}) {
  let trainers = await apiFetch({
    route: `trainer/venues?index=${page}${
      districtId
        ? occupationId
          ? `&districtId=${String(districtId)}&occupationId=${occupationId}`
          : `&districtId=${String(districtId)}`
        : ``
    }${occupationId && !districtId ? `&occupationId=${occupationId}` : ``}`,
  });

  return trainers;
}
